import _ from 'lodash';
import bowser from 'bowser';

export default angular
  .module('doxy.realtime.common.directives.bowser', [])
  .directive('dBowser', function () {
    return {
      restrict: 'AE',
      scope: false,
      link: function (scope, element, attrs) {
        let showFlags = attrs.dBowser ? attrs.dBowser.trim().split(',') : [];
        let hideFlags = attrs.dBowserHide
          ? attrs.dBowserHide.trim().split(',')
          : [];

        let enabledFeatures = Object.keys(bowser).filter(
          (k) => bowser[k] === true
        );
        let show =
          attrs.dBowser === '' ||
          !!_.intersection(enabledFeatures, showFlags).length;
        let hide = !!_.intersection(enabledFeatures, hideFlags).length;

        if (show && !hide) return;
        element.addClass('hide');
      },
    };
  }).name;
